// Get API URLs from environment variables
const API_BASE_URL_PRODUCTION = process.env.REACT_APP_API_BASE_URL_PRODUCTION || "https://be-myemployer.oldmutual.com.gh/api/v1/";
const API_BASE_URL_TEST = process.env.REACT_APP_API_BASE_URL_TEST || "https://testbe-myemployer.oldmutual.com.gh/api/v1/";

let base_url = "";
let browser_url = "";

// Getting the base URL from the browser
if (typeof window !== "undefined") {
    browser_url = window.location.host;
}

// Determine API base URL based on current host
switch (browser_url) {
    case "localhost:3000":
        // Development environment - use test API by default
        base_url = API_BASE_URL_TEST;
        break;
    case "ompensions-portal.vercel.app":
        // Vercel deployment - use test API same as localhost:3000
        base_url = API_BASE_URL_TEST;
        break;
    case "localhost:5000":
        base_url = API_BASE_URL_PRODUCTION;
        break;
    case "myemployer.oldmutual.com.gh":
        base_url = API_BASE_URL_PRODUCTION;
        break;
    case "test-myemployer.oldmutual.com.gh":
        base_url = API_BASE_URL_TEST;
        break;
    default:
        // Fallback to production API
        base_url = API_BASE_URL_PRODUCTION;
        break;
}

export default base_url;
